import { css } from 'styled-components'

export const CSSFullscreen = () => css`
width: 100vw;
height: 100vh;
`
